export const MEGATREND = 'megatrend'
export const MACROTREND = 'macrotrend'
export const RECOMMENDED_ACTION = 'recommendedAction'
export const READINESS_ASSESSMENT = 'readinessAssessment'
export const INNOVATION_FIELDS = 'innovationFields'
export const INNOVATION_PROJECTS = 'innovationProjects'

export const DATA_TABLE_COLUMNS_PREFIX = [
    MEGATREND,
    MACROTREND
]

export const DATA_TABLE_COLUMNS_POSTFIX = [
    RECOMMENDED_ACTION,
    READINESS_ASSESSMENT,
    INNOVATION_FIELDS,
    INNOVATION_PROJECTS
]
